import React from "react";
import { useSelector } from "react-redux";
import { Image } from "antd";
import Partners from "../../../../components/shared/Partners";
import Career from "../../../../components/shared/Career";
import Installment from "../../../../components/shared/Installment";
import VideosProgram from "../../../../components/shared/VideosProgram";
import TeachersProgram from "../../../../components/shared/TeachersProgram";
import ProgramInfo from "../../../../components/programs/ProgramInfo";
import ProgramsPopular from "../../../../components/programs/ProgramsPopular";
import ProgramDisciplines from "../../../../components/programs/ProgramDisciplines";
import ProgramConsultation from "../../../../components/programs/ProgramConsultation";
import Offer from "../../../../components/shared/Offer";
import { URL_PROFILE } from "../../../../config/config";
import { Title, ListOrdered, Section, Button, LinkDecor } from "@vshp/ui-components";
import Head from "next/head";
import PageNotFound from "../../../_error";
import { wrapper } from "../../../../store";
import { useRouter } from "next/router";
import { fetchProgram } from "../../../../actions/programs";

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({ query }) => {
  await store.dispatch(fetchProgram(query.id));

  return {
    props: {
      id: query.id,
    },
  };
});

function ProgramPage({ id }) {
  const router = useRouter();
  const { isReady } = router;
  const { program, programIsLoaded } = useSelector((state) => state.programs);

  if (!programIsLoaded && isReady) {
    return <PageNotFound />;
  }

  return (
    <>
      <Head>
        <title>{program.attributes.title}</title>
      </Head>
      <div className="page__header">
        <img className="page__header-cover" src={program.attributes.photo.cover} alt={program.attributes.title} />
        <div className="page__header-body page__header-body_center page__header-body_theme">
          <Title decor={false} className="page__header-title">
            {program.attributes.title}
          </Title>
          {program.attributes.tagline && program.attributes.tagline.length > 0 && <div className="page__header-intro" dangerouslySetInnerHTML={{ __html: program.attributes.tagline }}></div>}
          <Button
            className="page__header-btn"
            href={`${URL_PROFILE}/profile?${program.attributes["course-exists"] ? `refcid=${program.attributes["course-id"]}` : `refp=${program.attributes.title.replace(/ /g, "+")}`}`}
          >
            Начать обучение
          </Button>
        </div>
      </div>

      <div className="page__blocks">
        {program.attributes.description && program.attributes.description.length > 0 && (
          <Section className="wysiwyg" border={true}>
            <Title type="h2">ОПИСАНИЕ ПРОГРАММЫ</Title>
            <div dangerouslySetInnerHTML={{ __html: program.attributes.description }}></div>
          </Section>
        )}

        {program.attributes.presentation && (
          <Section border={true}>
            <Title type="h2">Презентация программы</Title>
            <LinkDecor link={program.attributes.presentation.url}>{program.attributes.presentation.title}</LinkDecor>
          </Section>
        )}

        {program.attributes.documents && program.attributes.documents.length > 0 && (
          <Section border={true}>
            <Title type="h2">ДОКУМЕНТЫ</Title>
            {program.attributes.documents.map(({ title, url }, id) => (
              <LinkDecor link={url} key={id}>
                {title}
              </LinkDecor>
            ))}
          </Section>
        )}

        {program.attributes.videos.data.length > 0 && <VideosProgram videos={program.attributes.videos.data} />}

        {program.attributes.advantages.length > 0 && (
          <Section>
            <Title type="h2">НАШ ПОДХОД В ОБУЧЕНИИ</Title>
            <ListOrdered isTwoColumns={true}>
              {program.attributes.advantages.map((text, key) => (
                <ListOrdered.Item key={key}>{text}</ListOrdered.Item>
              ))}
            </ListOrdered>
          </Section>
        )}

        {program.attributes.disciplines.length > 0 && <ProgramDisciplines disciplines={program.attributes.disciplines} planUrl={program.attributes["plan-url"]} />}

        <ProgramConsultation isNoSpaceBottom={program.attributes.certificates.length === 0} />

        {program.attributes.certificates.length > 0 && (
          <div className="page__block">
            <Title type="h2">По окончании обучения</Title>
            <div className="wysiwyg">
              <p>
                По&nbsp;окончании обучения вы&nbsp;станете специалистом по&nbsp;программе &laquo;{program.attributes.title}&raquo; и&nbsp;получите следующие документы для подтверждения ваших
                профессиональных знаний.
              </p>
            </div>

            <div className="photos">
              <Image.PreviewGroup>
                {program.attributes.certificates.map((item, key) => (
                  <Image
                    key={key}
                    src={item.preview}
                    preview={{
                      src: item.origin,
                    }}
                  />
                ))}
              </Image.PreviewGroup>
            </div>
          </div>
        )}

        {program.attributes.teachers.data.length > 0 && <TeachersProgram teachers={program.attributes.teachers.data} />}

        <Partners border={true} />

        {program.attributes.career.salary !== null && <Career salary={program.attributes.career.salary} vacancies={program.attributes.career.vacancies} />}

        <Installment />

        <ProgramInfo
          cost={program.attributes["details-cost"]}
          degree={program.attributes["details-degree"]}
          form={program.attributes["details-form"]}
          organization={program.attributes["details-organization"]}
          term={program.attributes["details-term"]}
        />

        <ProgramsPopular programId={id} />
        <Offer />
      </div>
    </>
  );
}

export default ProgramPage;
